<template>
  <button class="value-option" @click="onClick" v-bind:disabled="disabled" v-bind:class="[{'active': isActive}, extraClass]">{{text}}<slot></slot></button>
</template>

<script>
export default {
  props: ['onClick', 'disabled', 'text', 'isActive', 'extraClass']
}
</script>
